import { initContract } from "@ts-rest/core";

import {
  ClientSchema,
  ExtendedPartSchema,
  FileSchema,
  QuoteRequestLineSchema,
  QuoteRequestSchema,
} from "../types";
import { makePaginatedSchema, PaginationQuerySchema } from "../utils/zod-utils/makePaginatedSchema";

const c = initContract();

const QuoteRequestV2Schema = QuoteRequestSchema.extend({
  client: ClientSchema.nullable(),
  quoteRequestLines: QuoteRequestLineSchema.extend({
    part: ExtendedPartSchema.extend({
      files: FileSchema.array(),
    }),
  }).array(),
});

export const quoteRequestsV2Contract = c.router({
  findAll: {
    method: "GET",
    path: "/quote-requests/v2",
    query: PaginationQuerySchema,
    responses: {
      200: makePaginatedSchema(QuoteRequestV2Schema),
    },
  },
});
